import redirectRules from '../../public/_redirects?raw';
import { finalRoute, parseRedirects, rewriteInternalLinks } from '../../scripts/prerender-policy.mjs';

const redirects = parseRedirects(redirectRules);

export function canonicalInternalLink(href: string): string {
  const html = rewriteInternalLinks(`<a href="${href}">`, redirects);
  return html.match(/href="([^"]*)"/)?.[1] || href;
}

export const canonicalRoute = (route: string) => finalRoute(route, redirects);
export const canonicalHtmlLinks = (html: string) => rewriteInternalLinks(html, redirects);

/** Every exact redirect source with its final destination, for client-side routing. */
export const redirectEntries = [...redirects.keys()].map((source) => [source, finalRoute(source, redirects)] as const);
